import { api, USER_ENDPOINT } from "./client";
import type { User, UserUpdateRequest } from "@/types/user";

export const getUser = () =>
  api.get<User>(USER_ENDPOINT, { serviceId: null });

export const updateUser = (data: UserUpdateRequest) =>
  api.patch<User>(USER_ENDPOINT, data, { serviceId: null });
